export const GET_TAX_AMNESTY_OVR = 'TAX_AMNESTY/get_tax_amnesty_ovr';
export const GET_SINGLE_TAX_AMNESTY_OVR = 'TAX_AMNESTY/get_single_tax_amnesty_ovr';
export const UPDATE_TAX_AMNESTY_OVR = 'TAX_AMNESTY/update_tax_amnesty_ovr';
export const CREATE_TAX_AMNESTY_OVR = 'TAX_AMNESTY/create_tax_amnesty_ovr';
export const DELETE_TAX_AMNESTY_OVR = 'TAX_AMNESTY/delete_tax_amnesty_ovr';
export const GET_ORDINANCE_REVISION_EFFECTIVITY_AMNSESTY_OVR =
'TAX_AMNESTY/get_ordinance_reveision_amnesty_ovr';
export const EXPIRE_SOA_OVR = 'TAX_AMNESTY/expire_soa_ovr';

export const FORM_DATA = {
  name: '',
  description: '',
  ordinance_id: '',
  effectivity_start: '',
  effectivity_end: '',
};
